import { createApolloFetch } from "apollo-fetch";
import type { ChangeEvent } from "react";
import { useState } from "react";
import { configuration } from "../../../../../graphql/config";
import { Currency } from "../../../../../graphql/operations";
import Button from "../../../../Atoms/Button";
import Input from "../../../../Atoms/Input";
import { Text } from "../../../../Atoms/Typography";

const fetch = createApolloFetch({
  uri: configuration.API_URL,
});

interface Props {
  productId: string;
  couponCode: string | null;
  couponApplied: (code: any) => void;
  currency: Currency;
}

interface State {
  error: string | null;
  couponCode: string | null;
  shouldDisplayButton: boolean;
  shouldDisplayMessage: boolean;
}

export default function CouponCodePicker({
  productId,
  couponCode,
  couponApplied,
  currency,
}: Props) {
  const [state, setState] = useState<State>({
    error: null,
    couponCode: couponCode,
    shouldDisplayButton: false,
    shouldDisplayMessage: false,
  });

  function onTextChange(
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    setState({
      ...state,
      error: null,
      couponCode: e.target.value,
      shouldDisplayMessage: false,
      shouldDisplayButton: true,
    });
  }

  const applyCode = async () => {
    if (!state.couponCode) {
      return;
    }
    setState({
      ...state,
      shouldDisplayButton: false,
      shouldDisplayMessage: false,
    });

    const result = await fetch({
      query: GET_COUPON_DISCOUNT,
      variables: {
        productId: productId,
        code: state.couponCode,
        currency,
      },
    });

    if (!result.data) {
      setState({ ...state, error: "No response" });
      return;
    }
    const { coupon } = result.data;
    const checkCoupon = coupon !== null ? true : false;

    if (checkCoupon === false) {
      setState({
        ...state,
        shouldDisplayMessage: true,
        error: "Coupon Invalid",
      });

      couponApplied(null);
    } else {
      setState({
        ...state,
        error: null,
        shouldDisplayMessage: true,
      });

      couponApplied({
        ...coupon,
      });
    }
  };

  function renderMessage() {
    if (!state.shouldDisplayMessage) {
      return null;
    }

    if (state.error) {
      return <span style={{ color: "red" }}>{state.error}</span>;
    }
    return <Text color="success">You successfully applied your coupon</Text>;
  }

  return (
    <div>
      <Input
        name="coupon"
        placeholder="Enter your code, if you have one"
        value={state.couponCode || ""}
        onChange={onTextChange}
      />
      {renderMessage()}
      {state.shouldDisplayButton ? (
        <div style={{ marginTop: 5, textAlign: "right" }}>
          <Button small onClick={() => applyCode()}>
            apply code
          </Button>
        </div>
      ) : null}
    </div>
  );
}

export const GET_COUPON_DISCOUNT = `
  query GetDiscountCode($code: String!, $productId: ID!, $currency: Currency!) {
    coupon(code: $code, productId: $productId) {
      amount(currency: $currency) 
      code
      type
    }
  }
`;
